import { useMemo } from "react"
import { useLocation, useParams } from "react-router-dom"
import type { AiContext } from "@/lib/ai-types"

/**
 * Derives AI context from the current route.
 * Used to tell the AI agent what page/entity the user is viewing.
 */
export function useAiContext(): AiContext {
  const location = useLocation()
  const params = useParams()

  return useMemo(() => {
    const path = location.pathname
    const id = params.id

    // Match route patterns to context
    if (path.startsWith("/pipeline") || path.startsWith("/deals")) {
      if (id) return { current_page: path, context_type: "Deal", context_id: id }
      return { current_page: path }
    }
    if (path.startsWith("/companies")) {
      if (id) return { current_page: path, context_type: "Company", context_id: id }
      return { current_page: path }
    }
    if (path.startsWith("/contacts")) {
      if (id) return { current_page: path, context_type: "Contact", context_id: id }
      return { current_page: path }
    }
    if (path.startsWith("/tasks")) {
      if (id) return { current_page: path, context_type: "Task", context_id: id }
      return { current_page: path }
    }
    if (path.startsWith("/quotes")) {
      if (id) return { current_page: path, context_type: "Quote", context_id: id }
      return { current_page: path }
    }
    if (path.startsWith("/invoices")) {
      if (id) return { current_page: path, context_type: "Invoice", context_id: id }
      return { current_page: path }
    }
    if (path.startsWith("/service")) {
      if (id) return { current_page: path, context_type: "ServiceTicket", context_id: id }
      return { current_page: path }
    }

    return { current_page: path }
  }, [location.pathname, params.id])
}
